module.exports = __webpack_public_path__ + "media/A10.98c5e42d.mp3";